module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAK0lEQVRIx2NgaA8kiP5cFCMDMYwaPWr0qNFUN/qFoC4ZaNToUaNHjSYJAQCFquzznkZ+hgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/bj.png
// module id = 784
// module chunks = 0